var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showArticleListing
    ? _c("div", { staticClass: "wf-article-listing" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c(
            "div",
            { staticClass: "wf-article-listing-wrapper" },
            [
              _c("div", { staticClass: "wf-article-listing-heading" }, [
                _c("div", { staticClass: "wf-article-listing-title" }, [
                  _c(
                    "h2",
                    {
                      class:
                        "h3 m-0 " + (_vm.settings.center ? "text-center" : "")
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.settings.title) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.settings.showControls
                  ? _c("div", { staticClass: "wf-article-listing-controls" }, [
                      _c(
                        "div",
                        { staticClass: "wf-article-listing-controls-item" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "input-label",
                              attrs: { for: "article-type-" + _vm.settings.id }
                            },
                            [
                              _vm._v(
                                "\n              Content type:\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.query.type,
                                  expression: "query.type"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: {
                                name: "article-type",
                                id: "article-type-" + _vm.settings.id
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.query,
                                      "type",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.newQuery
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("\n                All\n              ")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.settings.typeOptions, function(
                                typeOption
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: typeOption.value,
                                    domProps: { value: typeOption.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(typeOption.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wf-article-listing-controls-item" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "input-label",
                              attrs: {
                                for: "article-category-" + _vm.settings.id
                              }
                            },
                            [_vm._v("\n              Category:\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.query.category,
                                  expression: "query.category"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: {
                                name: "article-category",
                                id: "article-category-" + _vm.settings.id
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.query,
                                      "category",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.newQuery
                                ]
                              }
                            },
                            [
                              _c("option", { attrs: { value: "" } }, [
                                _vm._v("\n                All\n              ")
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.settings.categoryOptions, function(
                                categoryOption
                              ) {
                                return _c(
                                  "option",
                                  {
                                    key: categoryOption.value,
                                    domProps: { value: categoryOption.value }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(categoryOption.name) +
                                        "\n              "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "wf-article-listing-controls-item" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "input-label",
                              attrs: { for: "article-sort-" + _vm.settings.id }
                            },
                            [_vm._v("\n              Sort:\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.query.sort,
                                  expression: "query.sort"
                                }
                              ],
                              staticClass: "custom-select",
                              attrs: {
                                name: "article-sort",
                                id: "article-sort-" + _vm.settings.id
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.query,
                                      "sort",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  _vm.newQuery
                                ]
                              }
                            },
                            _vm._l(_vm.settings.sortOptions, function(
                              sortOption
                            ) {
                              return _c(
                                "option",
                                {
                                  key: sortOption.value,
                                  domProps: { value: sortOption.value }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(sortOption.name) +
                                      "\n              "
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "wf-article-listing-grid" },
                _vm._l(_vm.articleListingItems, function(article) {
                  return _c(
                    "div",
                    { key: article.id, staticClass: "wf-article-listing-item" },
                    [
                      _c(
                        "div",
                        { staticClass: "wf-article-listing-item-inner" },
                        [
                          _c(
                            "div",
                            { staticClass: "wf-article-listing-item-image" },
                            [
                              _c("a", { attrs: { href: article.url } }, [
                                _c("img", {
                                  attrs: {
                                    src: article.teaserImage,
                                    alt: article.teaserImageAltText
                                  }
                                })
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wf-article-listing-item-tags" },
                            [
                              article.primaryTag
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-white text-primary m-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(article.primaryTag) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              article.secondaryTag
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "badge badge-white text-primary m-1"
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(article.secondaryTag) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wf-article-listing-item-body" },
                            [
                              _c("div", { staticClass: "secondary-heading" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(article.category) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("h3", { staticClass: "h4" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(article.title) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "wf-article-listing-item-date description"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(article.date) +
                                      "\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "mb-2",
                                domProps: { innerHTML: _vm._s(article.summary) }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "wf-article-listing-item-footer" },
                            [
                              article.type === "Videos"
                                ? _c(
                                    "wf-video-modal-button",
                                    {
                                      attrs: {
                                        "css-class":
                                          "call-to-action-button btn btn-white border-dark",
                                        "video-type": "element",
                                        "video-data": article.media1
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                Watch now\n                "
                                      ),
                                      _c("span", {
                                        staticClass:
                                          "png-icon png-icon-icons-glyph--k-play-fill"
                                      })
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "call-to-action-button btn btn-white border-dark",
                                  attrs: { href: article.url }
                                },
                                [
                                  _vm._v(
                                    "\n                View article\n                "
                                  ),
                                  _c("span", {
                                    staticClass:
                                      "png-icon png-icon-icons-glyph--k-arrow-next"
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _vm.status === "ready" && _vm.articleListingItems.length === 0
                ? _c("div", { staticClass: "wf-article-listing-status" }, [
                    _vm._v("\n        No articles found.\n      ")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.status === "error"
                ? _c("div", { staticClass: "wf-article-listing-status" }, [
                    _c("span", { staticClass: "text-danger" }, [
                      _vm._v(
                        "\n          An error occurred when retrieving news articles. Please try again.\n        "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasMoreResults
                ? _c("pc-load-more", { attrs: { "load-more": _vm.nextPage } })
                : _vm._e()
            ],
            1
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }